var RoleType;
(function (RoleType) {
    RoleType["Client"] = "CLIENT";
    RoleType["Developer"] = "DEVELOPER";
    RoleType["Realtor"] = "REALTOR";
    RoleType["Employee"] = "EMPLOYEE";
    RoleType["Makler"] = "MAKLER";
    RoleType["Professional"] = "PROFESSIONAL";
    RoleType["Contractor"] = "CONTRACTOR";
    RoleType["Designer"] = "DESIGNER";
    RoleType["Bank"] = "BANK";
    RoleType["Partner"] = "PARTNER";
    RoleType["IhcDeveloper"] = "IHC_DEVELOPER";
})(RoleType || (RoleType = {}));
const EMPTY_USER_INFO = {
    roles: [],
    permissions: [],
    userId: '',
    currentRole: '',
    currentRoleType: '',
    companyId: null,
    isAuthenticated: false,
    username: '',
    currentRoleDisplayName: '',
    companyBranchId: null,
    franchiseCompanyId: '',
};

/**
 * Список фич для которых может быть онбординг.
 * При добавлении новых фич, необходиммо поддержать их в onboarding-bff( в том числе и onboarding-бекенд ),
 * а так же в ROOT-компоненте DynamicOnboarding который подписан на данный eventBus
 */
var OnboardingFeatureEnum;
(function (OnboardingFeatureEnum) {
    OnboardingFeatureEnum["MenuItemMortage"] = "MenuItemMortage";
    OnboardingFeatureEnum["MenuItemPlacement"] = "MenuItemPlacement";
    OnboardingFeatureEnum["MenuItemFavorites"] = "MenuItemFavorites";
    OnboardingFeatureEnum["MenuItemProfSearch"] = "MenuItemProfSearch";
    OnboardingFeatureEnum["MenuItemProfCustomers"] = "MenuItemProfCustomers";
    OnboardingFeatureEnum["MenuItemProfFavorites"] = "MenuItemProfFavorites";
    OnboardingFeatureEnum["MenuItemProfSavedSearch"] = "MenuItemProfSavedSearch";
    OnboardingFeatureEnum["ProfSearchSnippetPresentation"] = "ProfSearchSnippetPresentation";
    OnboardingFeatureEnum["ProfSearchToolsPresentation"] = "ProfSearchToolsPresentation";
    OnboardingFeatureEnum["ProfSearchToolsSaveSearch"] = "ProfSearchToolsSaveSearch";
    OnboardingFeatureEnum["ProfSearchToolsToggleMapView"] = "ProfSearchToolsToggleMapView";
    OnboardingFeatureEnum["ProfSearchFilterClusterEnable"] = "ProfSearchFilterClusterEnable";
})(OnboardingFeatureEnum || (OnboardingFeatureEnum = {}));

var RemontCustomEventTypes;
(function (RemontCustomEventTypes) {
    RemontCustomEventTypes["SendMeetingRequest"] = "remont:landingEvent:sendMeetingRequest";
    RemontCustomEventTypes["SendMeetingResponse"] = "remont:landingEvent:sendMeetingResponse";
    RemontCustomEventTypes["SendMaintanceTicketRequest"] = "remont:landingEvent:sendMaintanceTicketRequest";
    RemontCustomEventTypes["SendMaintanceTicketResponse"] = "remont:landingEvent:sendMaintanceTicketResponse";
    RemontCustomEventTypes["CreateInvoiceRequest"] = "remont:landingEvent:createInvoiceRequest";
    RemontCustomEventTypes["CreateInvoiceResponse"] = "remont:landingEvent:createInvoiceResponse";
    RemontCustomEventTypes["GetPackageServicesRequest"] = "remont:landingEvent:getPackageServicesRequest";
    RemontCustomEventTypes["GetPackageServicesResponse"] = "remont:landingEvent:getPackageServicesResponse";
    RemontCustomEventTypes["ApplyPromocodeRequest"] = "remont:landingEvent:applyPromocodeRequest";
    RemontCustomEventTypes["ApplyPromocodeResponse"] = "remont:landingEvent:applyPromocodeResponse";
})(RemontCustomEventTypes || (RemontCustomEventTypes = {}));

export { EMPTY_USER_INFO, OnboardingFeatureEnum, RemontCustomEventTypes, RoleType };
